<template>
    <FormBuilder :formData="formData" :formValue="formValue"></FormBuilder>
</template>

<script>
    import FormBuilder from "../../FormBuilder.vue"

    export default {
        components: {
            FormBuilder
        },
        props: {
            formValue: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                formData: [
                    {
                        title: "Dispensing Unit Mapping",
                        anchor: "1.1",
                        description: "Create an aggregation to combine DUNs",
                        forms: [
                            {
                                label: "Mapping",
                                type: "sectionarray",
                                value: "dispensingUnit.mappings",
                                grid: "grid-50w",
                                buttonText: "Add mapping",
                                forms: [{
                                    type: "guid",
                                    value: "id"
                                }, {
                                    type: "text",
                                    label: "Name",
                                    value: "name",
                                    required: true
                                }, {
                                    type: "typeahead",
                                    label: "Select studies",
                                    value: "studies",
                                    required: true,
                                    multiple: true,
									appendAll: true,
                                    preValues: {
                                        field: "studies",
                                        name: "name",
                                        value: "id"
                                    },
                                    callback: (formValue) => {
                                        // Cleanup selected values when deleting items
                                        //debugger;
                                        this.aggregationCleanSelected(formValue, "dispensingUnitDataSources");
                                        this.buildApiAndDosage(formValue);
                                    }
                                }, {
                                    type: "aggregationtable",
                                    label: "Aggregation",
                                    value: "studies",
                                    extraClass: "grid-full",
                                    searchPlaceholder: "Search studies",
                                    valueGroup: "dispensingUnitDataSources",
                                    callback: (formValue) => {
                                        this.buildApiAndDosage(formValue);
                                    },
                                    rows: (table) => {
                                        let list = [];                                        
                                        for (let tg of table.data.treatmentGroups) {
                                            //debugger;
                                            for(let dun of tg.dispensingUnits){			
											    var dunName = table.data.dispensingUnits.find(x=>x.id==dun.id).name;
                                                //debugger;
                                                list.push({
                                                    id: table.studyId + "_" + table.forecastVersionId + "_" + tg.id + "_" + dun.uniqueId,
                                                    dunId: dun.id,
												    dunName: dunName,
												    //dunName: dun.idMetaValueName,
                                                    dunUniqueId: dun.uniqueId,
                                                    treatmentGroupName: tg.name,
                                                    treatmentGroupId: tg.id,
                                                });
                                            }
                                        }
                                        return list;
                                    },
                                    forms: [{
                                        type: "label",
                                        name: "DUN",
                                        value: "dunName",
                                        valueId: "dunUniqueId",
                                        valueGroup: "dispensingUnit"
                                    },{
                                        type: "label",
                                        name: "Treatment Group",
                                        value: "treatmentGroupName",
                                        valueId: "treatmentGroupId",
                                        valueGroup: "treatmentGroup"
                                    }]
                                }]
                            }
                        ]
                    }
                ]
            }
        },
        mounted (){
            // Rebuild all API and DF for each load to make sure new IDs is updated
            for(let mapping of this.formValue.dispensingUnit.mappings){
                //debugger;
                //alert("hej");
                this.buildApiAndDosage(mapping);
            }
        },
        methods: {
            // Build API and Dosage Form in background for each DUN selected
            buildApiAndDosage(formValue) {
                let apiList = [];
                let dfList = [];
                //debugger;
                for(let row of formValue.selectedRows){
                    let dunUniqueId = row.split("_")[3];
                    let treatmentGroupId = row.split("_")[2];
                    let forecastVersionId = row.split("_")[1]; // This is "study id" in final main Study.json file
                    let studyId = row.split("_")[0];                   
                    let table = this.$store.state.editor.version.data.studies.find(x => x.forecastVersionId === forecastVersionId);
                    if(!table)
                        continue;

                    if(!table.data)
                        table.data = this.$store.getters.forecastVersion(table.forecastVersionId).data;

                    let treatmentGroup = table.data.treatmentGroups.find(x => x.id === treatmentGroupId);
                    let dun = table.data.dispensingUnits.find(y => y.id === treatmentGroup.dispensingUnits.find(x => x.uniqueId === dunUniqueId).id);

                    let primaryPackageIds = [];
                    let secondaryPackageCount = 0;
                    for(let secondaryPackage of dun.secondaryPackages){
                        let sec = table.data.secondaryPackages.find(x => x.id === secondaryPackage.secondaryPackages);
                        let primaryPackageUniqueId = treatmentGroup.dispensingUnits.find(x => x.uniqueId === dunUniqueId).uniquePrimaryPackageIds[secondaryPackageCount];

                        primaryPackageIds.push({
                            id: sec.primaryPackageId,
                            unique: primaryPackageUniqueId
                        });

                        secondaryPackageCount++;
                    }

                    // Build lists based on primaryPackages
                    for(let primaryId of primaryPackageIds){
                        let primary = table.data.primaryPackages.find(x => x.id === primaryId.id);
                        let dosageForm = table.data.dosageForms.find(x => x.id === primary.value.dosageFormId);

                        let api = {
                            study: {
                                name: table.name,
                                id: forecastVersionId,
                                studyId: studyId // Real study id
                            },
                            dosageForm: {
                                name: dosageForm.name,
                                id: dosageForm.id
                            },
                            primaryPackage: {
                                name: primary.name,
                                id: primaryId.unique
                            }
                        };
                        apiList.push(api);

                        let df = {
                            study: {
                                name: table.name,
                                id: forecastVersionId,
                                studyId: studyId // Real study id
                            },
                            dosageForm: {
                                name: dosageForm.name,
                                id: dosageForm.id
                            },
                            primaryPackage: {
                                name: primary.name,
                                id: primaryId.unique
                            },
                            treatmentGroup: {
                                name: treatmentGroup.name,
                                id: treatmentGroup.id
                            }
                        };
                        dfList.push(df);
                    }
                }

                formValue.activeIngredientDataSources = apiList;
                formValue.dosageFormDataSources = dfList;
            }
        }
    }
</script>
